import { useState } from "react";
import {
  Alert,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import CrudPage from "components/CrudPage/CrudPage";
import { snack } from "components/Snack/Snack";
import baggageService from "services/admin/baggageService";
import {
  BAGGAGE_STATUS_OPTIONS,
  baggageStatusLabel,
} from "pages/Admin/Baggages/Baggage/baggage-status";

const BaggageScan = () => {
  const [tagCode, setTagCode] = useState("");
  const [status, setStatus] = useState("");
  const [note, setNote] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState<any>(null);

  const onScan = async () => {
    if (!tagCode || !status) {
      snack("Укажите бирку и новый статус");
      return;
    }
    setSubmitting(true);
    try {
      const res: any = await baggageService.scan({
        tagCode: tagCode.trim(),
        status,
        note: note || null,
      });
      setResult(res.data);
      snack(res.data?.changed ? "Статус обновлён" : "Статус не изменился");
    } catch (ex) {
      // Ошибки (невалидный переход / не найдено) показываются тостом через axios-интерсептор
      console.error(ex);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <CrudPage title="Сканирование багажа">
      <div className="flex flex-col gap-4" style={{ maxWidth: 480 }}>
        <TextField
          label="Код бирки"
          value={tagCode}
          onChange={(e) => setTagCode(e.target.value)}
          autoFocus
          fullWidth
        />

        <FormControl fullWidth>
          <InputLabel>Новый статус</InputLabel>
          <Select
            label="Новый статус"
            value={status}
            onChange={(e) => setStatus(e.target.value as string)}
          >
            {BAGGAGE_STATUS_OPTIONS.map((o) => (
              <MenuItem key={o.id} value={o.id}>
                {o.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Примечание (необязательно)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          multiline
          minRows={2}
          fullWidth
        />

        <Button variant="contained" disabled={submitting} onClick={onScan}>
          {submitting ? "Отправка..." : "Отсканировать"}
        </Button>

        {result?.data && (
          <Alert severity={result.changed ? "success" : "info"}>
            <div className="flex items-center gap-2">
              <b>{result.data.tagCode}</b>
              <Chip size="small" label={baggageStatusLabel(result.data.status)} />
              {!result.changed && <span>— статус не изменился</span>}
            </div>
          </Alert>
        )}
      </div>
    </CrudPage>
  );
};

export default BaggageScan;
